
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8D71D6"}},[_c('rect',{attrs:{"x":"4","y":"4","width":"14","height":"14","rx":"3"}}),_c('rect',{attrs:{"x":"22","y":"4","width":"14","height":"14","rx":"3"}}),_c('rect',{attrs:{"x":"4","y":"22","width":"14","height":"14","rx":"3"}}),_c('rect',{attrs:{"x":"22","y":"22","width":"14","height":"14","rx":"3"}})])])
          )
        }
      }
    